import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=1b53a73d&scoped=true&lang=pug"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"
import style0 from "./Device.vue?vue&type=style&index=0&id=1b53a73d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53a73d",
  null
  
)

export default component.exports